import { useEffect } from "react";

import { setSearchOption } from "./reducers/searchSlice";
import { getFilters } from "./reducers/api";
import { RiStarSmileLine } from "react-icons/ri";
import { IoHeart, IoLeaf, IoLocationSharp, IoPeopleSharp, IoPerson, IoRestaurantSharp, IoSnowOutline, IoWifi, IoWifiOutline } from "react-icons/io5";
import {
  MdAccessible,
  MdBeachAccess,
  MdChildCare,
  MdCleaningServices,
  MdDining,
  MdEco,
  MdElectricCar,
  MdFamilyRestroom,
  MdFitnessCenter,
  MdLocalHospital,
  MdLocalParking,
  MdLocationCity,
  MdOutlineBedroomBaby,
  MdOutlineKitchen,
  MdOutlineScubaDiving,
  MdPets,
  MdPool,
  MdRestaurant,
  MdSmokeFree,
  MdSpa,
  MdVolumeOff,
} from "react-icons/md";
import { GiBabyBottle, GiBabyFace, GiCarousel, GiDivingDagger, GiHotSurface, GiKidSlide, GiLotus, GiMeditation, GiSoccerBall, GiTennisCourt } from "react-icons/gi";
import { FaBicycle, FaDumbbell, FaHeart, FaHorse, FaMountain, FaRainbow, FaSailboat, FaSpa, FaSuitcaseRolling, FaUmbrellaBeach, FaUtensils, FaWater, FaWaveSquare } from "react-icons/fa6";
import { TbBabyCarriage, TbBeach, TbHorseToy, TbMassage, TbSwimming } from "react-icons/tb";
import { BsHouseDoor, BsMusicNoteBeamed, BsStar } from "react-icons/bs";
import { FaBiking, FaGolfBall, FaHiking, FaSkiing, FaSwimmer } from "react-icons/fa";
import { BiSolidWasher } from "react-icons/bi";
import { LuVegan } from "react-icons/lu";
import { PiGrainsSlash } from "react-icons/pi";

function intDividers(a) {
  let ma = [];
  for (let i = 1; i <= a; i++) {
    if (a % i === 0) {
      ma.push(i);
    }
  }
  return ma;
}

export const commonDivisors = (a, b) => {
  console.log(a, b);
  let factorsa = intDividers(a);
  let factorsb = intDividers(b);
  console.log(factorsa, factorsb);
  let res = [];
  for (let i = 0; i < factorsa.length; i++) {
    if (factorsb.includes(factorsa[i])) {
      res.push(factorsa[i]);
    }
  }

  return res;
};

export function useMountEffect(effect) {
  useEffect(() => {
    effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export const currencySymbol = (currCode) => {
  switch (currCode) {
    case "EUR":
      return "€";
    default:
      return currCode;
  }
};

export const dateAddMinute = (dts) => {
  if (typeof dts !== "string" || !dts.includes(":")) return "";
  let dat = new Date();
  dat.setHours(dts.split(":")[0] * 1);
  dat.setMinutes(dts.split(":")[1] * 1);
  dat.setTime(dat.getTime() + 60 * 1000);
  return (dat.getHours() < 10 ? "0" : "") + dat.getHours() + ":" + (dat.getMinutes() < 10 ? "0" : "") + dat.getMinutes();
};

export function consolelog(...args) {
  if (import.meta.env.DEV) {
    console.log(...args);
  }
}

export const roomAttributeInfos = [
  { value: "airCondition", label: "Klimaanlage", sort: 1 },
  { value: "fridge", label: "Kühlschrank", sort: 2 },
  { value: "poolView", label: "Poolblick", sort: 3 },
  /*{ value: "oceanView", label: "Meerblick", sort: 4 },*/
  { value: "privatePool", label: "Privater Pool", sort: 5 },
  { value: "privateWhirlpool", label: "Privater Whirlpool", sort: 6 },
  { value: "satelliteTV", label: "SAT-TV", sort: 7 },
  { value: "separateBedroom", label: "separates Schlafzimmer", sort: 8 },
  { value: "swimUpPool", label: "Swim Up Pool", sort: 9 },
  { value: "balconyOrTerrace", label: "Balkon/Terrasse", sort: 10 },
  {
    value: "atLeastTwoSeparateBedrooms",
    label: "mind. 2 separate Schlafzimmer",
  },
];

export const roomTypeInfos = [
  { value: "AccordingDescription", label: "nach Beschreibung", order: 1 },
  { value: "Caravan", label: "Caravan", order: 2 },
  { value: "SingleRoom", label: "Einzelzimmer", order: 3 },
  { value: "DoubleRoom", label: "Doppelzimmer", order: 4 },
  { value: "TwinRoom", label: "TwinRoom", order: 5 },
  { value: "ThreeBedRoom", label: "Dreibettzimmer", order: 6 },
  { value: "FamilyRoom", label: "FamilyRoom", order: 7 },
  { value: "FourBedRoom", label: "Vierbettzimmer", order: 8 },
  { value: "MultiBedRoom", label: "Mehrbettzimmer", order: 9 },
  { value: "DuplexRoom", label: "DuplexRoom", order: 10 },
  { value: "Suite", label: "Suite", order: 11 },
  { value: "Studio", label: "Studio", order: 12 },
  { value: "Apartment", label: "Appartment", order: 13 },
  { value: "Bungalow", label: "Bungalow", order: 14 },
  { value: "Villa", label: "Villa", order: 15 },
  { value: "SuperiorRoom", label: "SuperiorRoom", order: 16 },
  { value: "HolidayFlat", label: "Ferienwohnung", order: 17 },
  { value: "SummerCottage", label: "SummerCottage", order: 18 },
  { value: "DeluxeRoom", label: "DeluxeRoom", order: 19 },
];

export const stars = (amount) => {
  let s = "";
  for (let i = 0; i < amount; i++) s += "*";
  return s;
};

export const AppViews = Object.freeze({
  CLASSIC: "cl",
  CROSSCHECK: "cr",
  SECTION: "sc",
  SEARCH: "se",
  AIASSISTANT: "ai",
  BOOKING: "bu",
  CONFIRM: "cf",
  FAVORITE: "fv",
  PROFILE: "pf",
  DASHBOARD: "db",
});

export function holidayCheck(rating) {
  if (rating >= 5) return "Hervorragend";
  if (rating >= 4) return "Sehr gut";
  if (rating >= 3) return "Gut";
  if (rating >= 2) return "Befriedigend";
  return "Mangelhaft";
}

export function isMobile() {
  let isMobile = window.matchMedia("(max-width: 767px)").matches;

  return isMobile;
}

export const checkDifference = (offer, suboffer, isFlightIndependent) => {
  let betterOption = { better: false, options: [] };

  if (isFlightIndependent == undefined) {
    isFlightIndependent == false;
  }
  if (!isFlightIndependent) {
    if (
      !(
        offer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture.DepartureTime === suboffer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture.DepartureTime &&
        offer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture.DepartureTime === suboffer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture.DepartureTime
      )
    )
      return betterOption;
  } else {
    if (
      offer?.TravelDateInfo?.CheckInDate !== suboffer?.TravelDateInfo?.CheckInDate ||
      offer?.TravelDateInfo?.CheckOutDate !== suboffer?.TravelDateInfo?.CheckOutDate
    )
      return betterOption;
  }
  if (offer.TourOperator.TourOperatorName !== suboffer.TourOperator.TourOperatorName) return betterOption;

  if (offer.OfferID === suboffer.OfferID) return betterOption;

  betterOption.better = true;

  if (offer.OfferServices.Package.Accommodation.Room.RoomName !== suboffer.OfferServices.Package.Accommodation.Room.RoomName) {
    betterOption.options.push("roomName");
  }

  if (offer.OfferServices.Package.Accommodation.Room.RoomView !== suboffer.OfferServices.Package.Accommodation.Room.RoomView) {
    betterOption.options.push("roomView");
  }

  if (offer.OfferServices.Package.Accommodation.BoardType !== suboffer.OfferServices.Package.Accommodation.BoardType) {
    betterOption.options.push("boardType");
  }

  let transferinclOffer = 0;
  if (offer?.OfferProperties?.TransferInfos) {
    if (Array.isArray(offer.OfferProperties.TransferInfos) && offer.OfferProperties.TransferInfos.includes("TransferIncluded")) {
      transferinclOffer = 1;
    }
  }

  let transferinclSubOffer = 0;
  if (suboffer?.OfferProperties?.TransferInfos) {
    if (Array.isArray(suboffer.OfferProperties.TransferInfos) && suboffer.OfferProperties.TransferInfos.includes("TransferIncluded")) {
      transferinclSubOffer = 1;
    }
  }

  if (transferinclSubOffer - transferinclOffer < 0) {
    betterOption.options.push("transferNotIncluded");
  }

  if (transferinclSubOffer - transferinclOffer > 0) {
    betterOption.options.push("transferIncluded");
  }

  let railandflyOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (Array.isArray(offer.OfferProperties.OfferIncludes) && offer.OfferProperties.OfferIncludes.includes("RailAndFly")) {
      railandflyOffer = 1;
    }
  }

  let railandflySubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (Array.isArray(suboffer.OfferProperties.OfferIncludes) && suboffer.OfferProperties.OfferIncludes.includes("RailAndFly")) {
      railandflySubOffer = 1;
    }
  }

  if (railandflySubOffer - railandflyOffer < 0) {
    betterOption.options.push("railandflyNotIncluded");
  }

  if (railandflySubOffer - railandflyOffer > 0) {
    betterOption.options.push("railandflyIncluded");
  }

  let rentalcarOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (Array.isArray(offer.OfferProperties.OfferIncludes) && offer.OfferProperties.OfferIncludes.includes("RentalCar")) {
      rentalcarOffer = 1;
    }
  }

  let rentalcarSubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (Array.isArray(suboffer.OfferProperties.OfferIncludes) && suboffer.OfferProperties.OfferIncludes.includes("RentalCar")) {
      rentalcarSubOffer = 1;
    }
  }

  if (rentalcarSubOffer - rentalcarOffer < 0) {
    betterOption.options.push("rentalcarNotIncluded");
  }

  if (rentalcarSubOffer - rentalcarOffer > 0) {
    betterOption.options.push("rentalcarIncluded");
  }

  let freerebookOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (Array.isArray(offer.OfferProperties.OfferIncludes) && offer.OfferProperties.OfferIncludes.includes("FreeRebooking")) {
      freerebookOffer = 1;
    }
  }

  let freerebookSubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (Array.isArray(suboffer.OfferProperties.OfferIncludes) && suboffer.OfferProperties.OfferIncludes.includes("FreeRebooking")) {
      freerebookSubOffer = 1;
    }
  }

  if (freerebookSubOffer - freerebookOffer < 0) {
    betterOption.options.push("freerebookNotIncluded");
  }

  if (freerebookSubOffer - freerebookOffer > 0) {
    betterOption.options.push("freerebookIncluded");
  }

  let cancellationOffer = 0;
  if (offer?.OfferProperties?.CancellationOption === "Free") cancellationOffer = 3;
  if (offer?.OfferProperties?.CancellationOption === "Addable") cancellationOffer = 2;
  if (offer?.OfferProperties?.CancellationOption === "Paid") cancellationOffer = 1;

  let cancellationSubOffer = 0;
  if (suboffer?.OfferProperties?.CancellationOption === "Free") cancellationSubOffer = 3;
  if (suboffer?.OfferProperties?.CancellationOption === "Addable") cancellationSubOffer = 2;
  if (suboffer?.OfferProperties?.CancellationOption === "Paid") cancellationSubOffer = 1;

  if (cancellationSubOffer - cancellationOffer < 0) {
    betterOption.options.push("cancellationDowngrade");
  }

  if (cancellationSubOffer - cancellationOffer > 0) {
    betterOption.options.push("cancellationUpgrade");
  }

  return betterOption;
};

export const roomViewInfos = [
  {
    value: "PartialOcean",
    label: "Seitlicher Meerblick",
    filter: true,
    order: 1,
  },
  {
    value: "FullOcean",
    label: "Meerblick",
    filter: true,
    order: 3,
  },
  {
    value: "PartialOrFullOcean",
    label: "Seitlicher  Meerblick oder Meerblick",
    filter: true,
    order: 2,
  },
  {
    value: "NothingSpecial",
    label: "keine Auswahl",
    filter: false,
    order: 0,
  },
];

export const boardTypeInfos = [
  {
    value: "NoBoard",
    label: "Selbstverpflegung",
    short: "OV",
    order: 1,
    filter: true,

    searchKeys: [],
  },
  {
    value: "AccordingDescription",
    label: "nach Beschreibung",
    short: "LB",
    order: 2,
    filter: true,
    searchKeys: ["AccordingDescription"],
  },
  {
    value: "SelfCatering",
    label: "Selbstverpflegung",
    short: "OV",
    order: 3,
    filter: true,
    searchKeys: ["SelfCatering", "NoBoard"],
  },
  {
    value: "BreakfastEconomy",
    label: "Frühstück",
    short: "ÜFE",
    order: 4,
    filter: false,
    searchKeys: [],
  },
  {
    value: "Breakfast",
    label: "Frühstück",
    short: "ÜF",
    order: 4,
    filter: true,
    searchKeys: ["BreakfastEconomy", "Breakfast"],
  },
  {
    value: "BreakfastSuperior",
    label: "Frühstücksbuffet",
    short: "ÜF+",
    order: 5,
    filter: true,
    searchKeys: ["BreakfastSuperior"],
  },
  {
    value: "HalfBoardEconomy",
    label: "Halbpension",
    short: "HPE",
    order: 6,
    filter: false,
    searchKeys: [],
  },
  {
    value: "HalfBoard",
    label: "Halbpension",
    short: "HP",
    order: 6,
    filter: true,
    searchKeys: ["HalfBoardEconomy", "HalfBoard"],
  },
  {
    value: "HalfBoardSuperior",
    label: "Halbpension Plus",
    short: "HP+",
    order: 7,
    filter: true,
    searchKeys: ["HalfBoardSuperior"],
  },
  {
    value: "FullBoardEconomy",
    label: "Vollpension",
    short: "VPE",
    order: 8,
    filter: false,
    searchKeys: [],
  },
  {
    value: "FullBoard",
    label: "Vollpension",
    short: "VP",
    order: 8,
    filter: true,
    searchKeys: ["FullBoardEconomy", "FullBoard"],
  },
  {
    value: "FullBoardSuperior",
    label: "Vollpension Plus",
    short: "VP+",
    order: 9,
    filter: true,
    searchKeys: ["FullBoardSuperior"],
  },
  {
    value: "AllInclusiveEconomy",
    label: "All Inclusive",
    short: "AIE",
    order: 10,
    filter: false,
    searchKeys: [],
  },
  {
    value: "AllInclusive",
    label: "All Inclusive",
    short: "AI",
    order: 10,
    filter: true,
    searchKeys: ["AllInclusiveEconomy", "AllInclusive"],
  },
  {
    value: "AllInclusiveSuperior",
    label: "Ultra All Inclusive",
    short: "UAI",
    order: 11,
    filter: true,
    searchKeys: ["AllInclusiveSuperior"],
  },
];

export const propertyFromArray = (array, value, valueProperty, outputProperty) => {
  if (!Array.isArray(array)) return "";
  let opt = array.find((e) => e[valueProperty] === value);
  if (opt) {
    return opt[outputProperty] ? opt[outputProperty] : "";
  }
  return "";
};

export const updateairlines = (dispatch, airlines, originalPromiseResult, airlinerank, nolowcost, linie) => {
  let oplines = [];
  if (!Array.isArrayoriginalPromiseResult?.TransportOperatingBrands?.TransportOperatingBrand) return;
  for (let i = 0; i < originalPromiseResult.TransportOperatingBrands.TransportOperatingBrand.length; i++) {
    let a = airlines.find((f) => f.value === originalPromiseResult.TransportOperatingBrands.TransportOperatingBrand[i].Code);
    oplines.push({
      value: originalPromiseResult.TransportOperatingBrands.TransportOperatingBrand[i].Code,
      label: originalPromiseResult.TransportOperatingBrands.TransportOperatingBrand[i].Name,
      properties: a ? a.properties : {},
    });
  }

  reevaluateAirlines(dispatch, oplines, airlinerank, nolowcost, linie);
};

export const reevaluateAirlines = (dispatch, destinationAirlines, airlinerank, nolowcost, linie) => {
  //let val = !airlinerank;

  let brands = [...destinationAirlines];
  if (airlinerank && brands.length > 0) {
    brands = brands.filter((e) => e.properties?.ranking < 3);
  }

  if (nolowcost && brands.length > 0) {
    brands = brands.filter((e) => e.properties?.type !== "Low Cost");
  }

  if (linie && brands.length > 0) {
    brands = brands.filter((e) => e.properties?.type === "Linie");
  }

  if (!linie && !nolowcost && !airlinerank) {
    brands = [];
  }

  if (brands.length > 0)
    dispatch(
      setSearchOption({
        property: "operatingbrand",
        data: brands.map((e) => e.value),
      }),
    );
  else
    dispatch(
      setSearchOption({
        property: "operatingbrand",
        data: [],
      }),
    );

  dispatch(
    setSearchOption({
      property: "airlinerank",
      data: airlinerank,
    }),
  );

  dispatch(
    setSearchOption({
      property: "nolowcost",
      data: nolowcost,
    }),
  );

  dispatch(
    setSearchOption({
      property: "linie",
      data: linie,
    }),
  );

  getFilters(dispatch, false);
};

export const airportcity = (iata) => {
  if (iata === "ACH") return iata + " (St. Gallen)";
  if (iata === "AMS") return iata + " (Amsterdam)";
  if (iata === "BER") return iata + " (Berlin-Brandenburg)";
  if (iata === "BRE") return iata + " (Bremen)";
  if (iata === "BLL") return iata + " (Billund)";
  if (iata === "BRN") return iata + " (Bern)";

  if (iata === "BRQ") return iata + " (Brünn)";
  if (iata === "BRU") return iata + " (Brüssel-Zaventem)";
  if (iata === "BSL") return iata + " (Basel)";
  if (iata === "BTS") return iata + " (Bratislava)";

  if (iata === "CGN") return iata + " (Köln-Bonn)";
  if (iata === "CPH") return iata + " (Kopenhagen)";
  if (iata === "CRL") return iata + " (Brüssell-Charleroi)";
  if (iata === "DRS") return iata + " (Dresden)";
  if (iata === "DTM") return iata + " (Dortmund)";
  if (iata === "DUS") return iata + " (Düsseldorf)";
  if (iata === "EIN") return iata + " (Eindhoven)";
  if (iata === "ERF") return iata + " (Erfurt-Weimar)";
  if (iata === "FDH") return iata + " (Bodensee-Airport Friedrichshafen)";
  if (iata === "FKB") return iata + " (Karlsruhe/Baden-Baden)";
  if (iata === "FMM") return iata + " (Memmingen)";
  if (iata === "FMO") return iata + " (Münster/Osnabrück)";
  if (iata === "FRA") return iata + " (Frankfurt Am Main)";
  if (iata === "GDN") return iata + " (Danzig)";

  if (iata === "GRQ") return iata + " (Groningen)";
  if (iata === "GRZ") return iata + " (Graz)";
  if (iata === "GVA") return iata + " (Genf)";
  if (iata === "GWT") return iata + " (Sylt)";
  if (iata === "HAJ") return iata + " (Hannover)";
  if (iata === "HAM") return iata + " (Hamburg)";
  if (iata === "HHN") return iata + " (Frankfurt-Hahn)";
  if (iata === "INN") return iata + " (Innsbruck)";
  if (iata === "KLU") return iata + " (Klagenfurt)";
  if (iata === "KRK") return iata + " (Krakay)";
  if (iata === "KSC") return iata + " (Košice)";

  if (iata === "KSF") return iata + " (Kassel)";
  if (iata === "KTW") return iata + " (Katowice)";

  if (iata === "LBC") return iata + " (Lübeck)";
  if (iata === "LCJ") return iata + " (Łódź)";

  if (iata === "LEJ") return iata + " (Leipzig/Halle)";
  if (iata === "LNZ") return iata + " (Linz)";

  if (iata === "LUX") return iata + " (Luxemburg)";
  if (iata === "LYS") return iata + " (Lyon)";
  if (iata === "LZS") return "HBF Linz";
  if (iata === "MLH") return iata + " (Mulhouse)";
  if (iata === "MST") return iata + " (Maastricht-Aachen)";
  if (iata === "MUC") return iata + " (München)";
  if (iata === "NRN") return iata + " (Niederrhein)";
  if (iata === "NUE") return iata + " (Nürnberg)";
  if (iata === "OSR") return iata + " (Ostrava)";
  if (iata === "PAD") return iata + " (Paderborn-Lippstadt)";
  if (iata === "POZ") return iata + " (Posen)";
  if (iata === "PRG") return iata + " (Prag)";

  if (iata === "QDL") return iata + " (Lugano)";
  if (iata === "QDU") return "HBF Düsseldorf ";
  if (iata === "QKL") return "HBF Köln";
  if (iata === "QKU") return "BF Köln-Deutz";
  if (iata === "QPP") return "HBF Berlin";
  if (iata === "RLG") return iata + " (Rostock-Laage)";
  if (iata === "RTM") return iata + " (Rotterdam)";
  if (iata === "SCN") return iata + " (Saarbrücken)";
  if (iata === "STR") return iata + " (Stuttgart)";
  if (iata === "SXB") return iata + " (Straßburg)";
  if (iata === "SXF") return iata + " (Berlin Schönefeld)";
  if (iata === "SZG") return iata + " (Salzburg)";
  if (iata === "SZZ") return iata + " (Stettin)";
  if (iata === "TXL") return iata + " (Berlin-Tegel)";
  if (iata === "VIE") return iata + " (Wien-Schwechat)";
  if (iata === "WAW") return iata + " (Warschau Chopin)";
  if (iata === "WMI") return iata + " (Warschau-Modlin)";
  if (iata === "WRO") return iata + " (Breslau)";

  if (iata === "XIR") return "HBF Dresden";
  if (iata === "XIT") return "HBF Leipzig";
  if (iata === "ZAQ") return "HBF Nürnberg";
  if (iata === "ZDH") return "HBF Basel";
  if (iata === "ZHT") return "HBF Genf";
  if (iata === "ZMB") return "HBF Hamburg";
  if (iata === "ZMU") return "HBF München";
  if (iata === "ZPE") return "HBF Osnabrück";
  if (iata === "ZRH") return iata + " (Zürich)";
  if (iata === "ZSB") return "HBF Salzburg";
  if (iata === "ZVR") return "HBF Hannover";
  if (iata === "ZWS") return "HBF Stuttgart";
  if (iata === "PED") return iata + " (Pardubice)";
  if (iata === "RZE") return iata + " (Rzeszów-Jasionka)";
  if (iata === "ANR") return iata + " (Antwerpen)";
};

export const childrenOptions = [
  { value: "0", label: "kein Kind" },
  { value: "1", label: "1 Kind" },
  { value: "2", label: "2 Kinder" },
  { value: "3", label: "3 Kinder" },
  { value: "4", label: "4 Kinder" },
];

export const childrenAgeOptions = [
  { value: "0", label: "Alter" },
  { value: "1", label: "< 2 Jahre" },
  { value: "2", label: "2 Jahre" },
  { value: "3", label: "3 Jahre" },
  { value: "4", label: "4 Jahre" },
  { value: "5", label: "5 Jahre" },
  { value: "6", label: "6 Jahre" },
  { value: "7", label: "7 Jahre" },
  { value: "8", label: "8 Jahre" },
  { value: "9", label: "9 Jahre" },
  { value: "10", label: "10 Jahre" },
  { value: "11", label: "11 Jahre" },
  { value: "12", label: "12 Jahre" },
  { value: "13", label: "13 Jahre" },
  { value: "14", label: "14 Jahre" },
  { value: "15", label: "15 Jahre" },
  { value: "16", label: "16 Jahre" },
  { value: "17", label: "17 Jahre" },
];

export const adultsOptions = [
  { value: "1", label: "1 Erwachsener" },
  { value: "2", label: "2 Erwachsene" },
  { value: "3", label: "3 Erwachsene" },
  { value: "4", label: "4 Erwachsene" },
  { value: "5", label: "5 Erwachsene" },
  { value: "6", label: "6 Erwachsene" },
];

export const daysInThisMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

export const hotelAttributeInfos = [
  {
    value: "action_adventures_parties_fun",
    label: "Action & Fun",
    icon: RiStarSmileLine,
    order: 401,
    group: "Aktivurlaub",
  },
  {
    value: "adults_only",
    label: "Adults Only",
    group: "Zielgruppe",
    icon: IoPeopleSharp,
    order: 108,
    mostwanted: true,
    info: "adults_only",
  },
  {
    value: "attractive_for_couples",
    label: "Urlaub zu zweit",
    group: "Zielgruppe",
    icon: IoHeart,
    order: 106,
  },
  {
    value: "attractive_for_singles",
    label: "Single",
    group: "Zielgruppe",
    icon: IoPerson,
    order: 104,
  },
  {
    value: "attractive_for_singles_w_child",
    label: "Single mit Kind",
    group: "Zielgruppe",
    icon: MdChildCare,
    order: 105,
  },
  {
    value: "ayurveda",
    label: "Ayurveda",
    icon: GiLotus,
    order: 301,
    group: "Body 'n' soul",
  },
  {
    value: "baby_cot",
    label: "Babybett",
    icon: MdOutlineBedroomBaby,
    order: 200,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "baby_equipment",
    label: "Babyausstattung",
    icon: GiBabyBottle,
    order: 201,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "babysitting",
    label: "Babysitter",
    icon: GiBabyFace,
    order: 202,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "beauty_farm",
    label: "Wellnessanwendungen",
    icon: FaSpa,
    order: 301,
    group: "Body 'n' soul",
  },
  {
    value: "bike_mountainbike_rental",
    label: "Rad/Mountainbike",
    icon: FaBicycle,
    order: 500,
    group: "Sport",
  },
  {
    value: "buffet_for_children",
    label: "Kinderbuffet",
    icon: MdDining,
    order: 203,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "buggy_rent",
    label: "Buggy Service",
    icon: TbBabyCarriage,
    order: 204,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "central_location",
    label: "Zentrale Lage",
    icon: IoLocationSharp,
    order: 205,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "city_breaks",
    label: "Stadthotel",
    icon: MdLocationCity,
    order: 206,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "club_with_entertainment",
    label: "Club",
    icon: BsMusicNoteBeamed,
    order: 207,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "cosmetic_treatments",
    label: "Wellnessanwendungen",
    icon: MdSpa,
    order: 303,
    group: "Body 'n' soul",
  },
  {
    value: "direct_beach_access",
    label: "Direkte Strandlage",
    icon: MdBeachAccess,
    order: 208,
    mostwanted: true,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "direct_proximity_ski_lift",
    label: "Direkt am Skilift",
    icon: FaSkiing,
    order: 209,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "diving_close_to_hotel",
    label: "Tauchen",
    icon: MdOutlineScubaDiving,
    order: 501,
    group: "Sport",
  },
  {
    value: "elegant_deluxe",
    label: "Deluxe",
    icon: BsStar,
    order: 210,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "family_benefits",
    label: "Familienvergünstigungen",
    icon: MdFamilyRestroom,
    order: 102,
    group: "Zielgruppe",
  },
  {
    value: "family_friendly",
    label: "Familien",
    group: "Zielgruppe",
    icon: MdFamilyRestroom,
    order: 101,
    mostwanted: true,
  },
  {
    value: "family_friendly_2",
    label: "Familien",
    group: "Zielgruppe",
    icon: MdFamilyRestroom,
    order: 101,
    hide: true,
  },
  {
    value: "free_parking",
    label: "Kostenloser Parkplatz",
    icon: MdLocalParking,
    order: 212,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "free_wlan",
    label: "freies WLAN",
    icon: IoWifi,
    order: 213,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "gay_hotels",
    label: "Gay Hotels",
    group: "Zielgruppe",
    icon: FaRainbow,
    order: 104,
  },
  {
    value: "LGBTQ",
    label: "LGBTQIA+",
    group: "Zielgruppe",
    icon: FaRainbow,
    order: 110,
  },
  {
    value: "gently_sloping_sandy_beach",
    label: "fl. abfall. Sandstrand",
    icon: TbBeach,
    order: 214,
    mostwanted: true,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "german_entertainment_for_kids",
    label: "Deutschsprachige Kinderbetreuung",
    icon: TbHorseToy,
    order: 215,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "golf_close_to_hotel",
    label: "Golf",
    icon: FaGolfBall,
    order: 505,
    group: "Sport",
  },
  {
    value: "golf_close_to_hotel_2",
    label: "Golf",
    icon: FaGolfBall,
    order: 506,
    hide: true,
    group: "Sport",
  },
  {
    value: "great_sports_offer",
    label: "Großes Sportangebot",
    icon: FaDumbbell,
    order: 407,
    group: "Aktivurlaub",
  },
  {
    value: "handicapped_accessible",
    label: "Barrierefrei",
    icon: MdAccessible,
    order: 218,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "heated_pool",
    label: "beheizbarer Pool",
    icon: GiHotSurface,
    order: 219,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "horseback_riding_close_to_hotel",
    label: "Reiten",
    icon: FaHorse,
    order: 510,
    group: "Sport",
  },
  {
    value: "hotel_in_hiking_region",
    label: "Wandern",
    icon: FaHiking,
    order: 511,
    group: "Sport",
  },
  {
    value: "hotel_near_beach",
    label: "Strandnah (max. 400m)",
    icon: FaUmbrellaBeach,
    order: 220,
    mostwanted: true,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "hygienic_measures",
    label: "Besondere Hygienemaßnahmen",
    icon: MdCleaningServices,
    order: 221,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "kids_disco",
    label: "Kinderdisko",
    icon: BsMusicNoteBeamed,
    order: 222,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "laundry_service",
    label: "Wäscheservice",
    icon: BiSolidWasher,
    order: 223,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "long_haul_journey",
    label: "Langzeithotels",
    icon: FaSuitcaseRolling,
    order: 224,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "massages_and_body_treatments",
    label: "Massagen",
    icon: TbMassage,
    order: 301,
    group: "Body 'n' soul",
  },
  {
    value: "maxi_club_7to12_years",
    label: "Kinderclub (7-12 Jahre)",
    icon: MdChildCare,
    order: 225,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "medical_service",
    label: "Arztservice",
    icon: MdLocalHospital,
    order: 226,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "mini_club_3to6_years",
    label: "Miniclub (3-6 Jahre)",
    icon: MdChildCare,
    order: 227,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "nice_small_family_run_hotel",
    label: "Klein/Familiär/Nett",
    icon: BsHouseDoor,
    order: 228,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "non_smoking_hotel",
    label: "Nichtraucherhotel",
    icon: MdSmokeFree,
    order: 229,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "non_smoking_rooms",
    label: "Nichtraucherzimmer",
    icon: MdSmokeFree,
    order: 230,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "other_theme_parks",
    label: "Freizeitpark",
    icon: GiCarousel,
    order: 231,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "own_fitness_facilities",
    label: "Fitnessraum",
    icon: MdFitnessCenter,
    order: 401,
    group: "Aktivurlaub",
  },
  {
    value: "own_indoor_pool",
    label: "Hallenbad",
    icon: MdPool,
    order: 232,
    group: "Unterkunft / Umgebung",
    mostwanted: true,
  },
  {
    value: "own_outdoor_pool",
    label: "Schwimmbad",
    icon: FaSwimmer,
    order: 233,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "vegetarian",
    label: "Vegetarisch",
    icon: IoLeaf,
    order: 280,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "vegan",
    label: "Vegan",
    icon: LuVegan,
    order: 281,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "glutenfree",
    label: "Glutenfrei",
    icon: PiGrainsSlash,
    order: 282,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "a_la_carte",
    label: "A la Carte",
    icon: IoRestaurantSharp,
    order: 283,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "swim_up_pool",
    label: "Swimm-Up Zimmer",
    icon: TbSwimming,
    order: 284,
    group: "Unterkunft / Umgebung",
    mostwanted: true,
  },
  {
    value: "organic_food",
    label: "Bio-Lebensmittel",
    icon: MdEco,
    order: 285,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "car_charging_stations",
    label: "Ladestation für Fahrzeuge",
    icon: MdElectricCar,
    order: 286,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "electric_bike",
    label: "E-Bikes",
    icon: FaBiking,
    order: 287,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "own_sauna_bathing_facilities",
    label: "Dampfbad&Sauna",
    icon: FaSpa,
    order: 234,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "own_squash_court",
    label: "Squash",
    icon: GiTennisCourt,
    order: 502,
    group: "Sport",
  },
  {
    value: "own_tennis_court",
    label: "Tennis",
    icon: GiTennisCourt,
    order: 503,
    group: "Sport",
  },
  {
    value: "own_water_slide",
    label: "Wasserrutschen",
    icon: GiKidSlide,
    order: 235,
    group: "Unterkunft / Umgebung",
    mostwanted: true,
  },
  {
    value: "own_water_sports_facilities",
    label: "Wassersport",
    icon: FaWater,
    order: 504,
    group: "Sport",
  },
  {
    value: "own_wellness_facilities",
    label: "Wellness",
    icon: MdSpa,
    order: 302,
    group: "Body 'n' soul",
    mostwanted: true,
  },
  {
    value: "parking_spaces_available",
    label: "Parkmöglichkeit",
    icon: MdLocalParking,
    order: 236,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "pets_allowed",
    label: "Haustier erlaubt",
    icon: MdPets,
    order: 237,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "petting_zoo",
    label: "Streichelzoo",
    icon: MdPets,
    order: 238,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "playground_for_children",
    label: "Kinderspielplatz",
    icon: MdChildCare,
    order: 239,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "playroom_for_children",
    label: "Kinderspielraum",
    icon: MdChildCare,
    order: 240,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "pool_for_children",
    label: "Kinderpool",
    icon: MdChildCare,
    order: 241,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "quiet_location",
    label: "Ruhige Lage",
    icon: MdVolumeOff,
    order: 242,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "relaxation_for_body_and_soul",
    label: "Body&Soul",
    icon: GiMeditation,
    order: 305,
    group: "Body 'n' soul",
  },
  {
    value: "restaurant",
    label: "Restaurant",
    icon: MdRestaurant,
    order: 243,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "sailing_close_to_hotel",
    label: "Segeln",
    icon: FaSailboat,
    order: 505,
    group: "Sport",
  },
  {
    value: "sandy_beach",
    label: "Sandstrand",
    icon: TbBeach,
    order: 244,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "soccer_school",
    label: "Fussballschule",
    icon: GiSoccerBall,
    order: 509,
    group: "Sport",
  },
  {
    value: "special_atmosphere_design",
    label: "Charme/Flair",
    icon: BsStar,
    order: 307,
    group: "Body 'n' soul",
  },
  {
    value: "special_culinary_delights",
    label: "Gourmet/Genießens",
    icon: FaUtensils,
    order: 308,
    group: "Body 'n' soul",
  },
  {
    value: "specials_for_newly_married",
    label: "für Hochzeitsreisende",
    icon: FaHeart,
    order: 107,
    group: "Zielgruppe",
  },
  {
    value: "sporting_activities_for_children",
    label: "Sportangebot für Kinder",
    icon: GiSoccerBall,
    order: 508,
    group: "Sport",
  },
  {
    value: "surfing_close_to_hotel",
    label: "Surfen",
    icon: FaWaveSquare,
    order: 512,
    group: "Sport",
  },
  {
    value: "swim_school",
    label: "Schwimmschule",
    icon: FaSwimmer,
    order: 245,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "thalasso_treatments",
    label: "Thalasso",
    icon: FaWater,
    order: 317,
    group: "Body 'n' soul",
  },
  {
    value: "vacation_at_mediterranean_sea",
    label: "Hotel am Mittelmeer",
    icon: FaUmbrellaBeach,
    order: 246,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "vacation_at_north_baltic_sea",
    label: "Hotel an der Ostsee",
    icon: FaUmbrellaBeach,
    order: 247,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "vacation_in_the_mountains",
    label: "Hotel in den Bergen",
    icon: FaMountain,
    order: 249,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "winter_sports_ski_area",
    label: "Hotel am Skigebiet",
    icon: IoSnowOutline,
    order: 250,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "wlan_available",
    label: "WLAN verfügbar",
    icon: IoWifiOutline,
    order: 251,
    group: "Unterkunft / Umgebung",
  },
  {
    value: "certified_sustainable",
    label: "Zertifiziert nachhaltige Unterkunft",
    icon: MdEco,
    mostwanted: true,
    order: 252,
    group: "Unterkunft / Umgebung",
  },
];

export const giataOperators = [
  {
    vc: "1AV",
    vi: "710",
    vn: "1AVista Reisen GmbH",
    logo: [
      {
        size: "20",
        width: "41",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=1av&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=1av&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=1av&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=1av&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "247T",
    vi: "1142",
    vn: "247 Travel Collection",
    logo: [
      {
        size: "20",
        width: "33",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=247t&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=247t&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=247t&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=247t&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "5VF",
    vi: "443",
    vn: "5 vor Flug",
    logo: [
      {
        size: "20",
        width: "28",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vf&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vf&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vf&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vf&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "5VFCH",
    vi: "997",
    vn: "5 vor Flug Schweiz",
    logo: [
      {
        size: "20",
        width: "27",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vfch&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vfch&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vfch&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=5vfch&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "AARE",
    vi: "1028",
    vn: "Aaretal Reisen",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aare&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aare&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aare&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aare&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ABLU",
    vi: "1124",
    vn: "Adrialin Blue GmbH",
    logo: [
      {
        size: "20",
        width: "72",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ablu&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ablu&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ablu&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ablu&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ADRI",
    vi: "1077",
    vn: "Adrialin GmbH",
    logo: [
      {
        size: "20",
        width: "65",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=adri&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=adri&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=adri&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=adri&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ATID",
    vi: "202",
    vn: "airtours",
    logo: [
      {
        size: "20",
        width: "29",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ATIS",
    vi: "1013",
    vn: "airtours Suisse",
    logo: [
      {
        size: "20",
        width: "29",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ati&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "AWT",
    vi: "494",
    vn: "Airways Travel GmbH",
    logo: [
      {
        size: "20",
        width: "58",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=awt&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=awt&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=awt&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=awt&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ALD",
    vi: "230",
    vn: "Aldiana",
    logo: [
      {
        size: "20",
        width: "20",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ald&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ald&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ald&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ald&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ALDX",
    vi: "1153",
    vn: "Aldiana ALDX",
    logo: [
      {
        size: "20",
        width: "52",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aldx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aldx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aldx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=aldx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ALL",
    vi: "248",
    vn: "Alltours",
    logo: [
      {
        size: "20",
        width: "71",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=all&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=all&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=all&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=all&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XALL",
    vi: "856",
    vn: "Alltours XALL",
    logo: [
      {
        size: "20",
        width: "75",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xall&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xall&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xall&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xall&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "AME",
    vi: "271",
    vn: "Ameropa-Reisen",
    logo: [
      {
        size: "20",
        width: "81",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ame&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ame&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ame&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ame&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ANEX",
    vi: "1082",
    vn: "Anex Tour",
    logo: [
      {
        size: "20",
        width: "45",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=anex&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=anex&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=anex&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=anex&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XANE",
    vi: "1109",
    vn: "Anex Tour XANE",
    logo: [
      {
        size: "20",
        width: "45",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xane&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xane&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xane&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xane&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ATK",
    vi: "169",
    vn: "Attika",
    logo: [
      {
        size: "20",
        width: "91",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=atk&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=atk&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=atk&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=atk&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BAV",
    vi: "447",
    vn: "Bavaria Fernreisen GmbH",
    logo: [
      {
        size: "20",
        width: "44",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bav&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bav&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bav&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bav&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BCH",
    vi: "557",
    vn: "Bentour Reisen",
    logo: [
      {
        size: "20",
        width: "56",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bch&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bch&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bch&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bch&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BENX",
    vi: "1087",
    vn: "BENX",
    logo: [
      {
        size: "20",
        width: "54",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=benx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=benx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=benx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=benx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BM",
    vi: "680",
    vn: "Berge und Meer",
    logo: [
      {
        size: "20",
        width: "89",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bm&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bm&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bm&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bm&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BIG",
    vi: "364",
    vn: "Big-Xtra Touristik GmbH",
    logo: [
      {
        size: "20",
        width: "72",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=big&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=big&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=big&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=big&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BXCH",
    vi: "945",
    vn: "Big-Xtra Touristik GmbH (Schweiz)",
    logo: [
      {
        size: "20",
        width: "72",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bxch&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bxch&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bxch&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bxch&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ITSB",
    vi: "322",
    vn: "Billa Reisen",
    logo: [
      {
        size: "20",
        width: "33",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsb&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsb&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsb&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsb&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BOT",
    vi: "1133",
    vn: "BOTROS TOURS GMBH",
    logo: [
      {
        size: "20",
        width: "46",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bot&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bot&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bot&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bot&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BU",
    vi: "190",
    vn: "BUCHER REISEN",
    logo: [
      {
        size: "20",
        width: "39",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bu&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bu&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bu&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bu&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "BYE",
    vi: "753",
    vn: "byebye",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bye&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bye&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bye&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=bye&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "CHRI",
    vi: "313",
    vn: "Christophorus Reiseveranstaltungs GmbH",
    logo: [
      {
        size: "20",
        width: "91",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=chri&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=chri&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=chri&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=chri&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "CLEV",
    vi: "664",
    vn: "clevertours.com",
    logo: [
      {
        size: "20",
        width: "153",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=clev&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=clev&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=clev&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=clev&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "COR",
    vi: "1119",
    vn: "Coral Travel GmbH",
    logo: [
      {
        size: "20",
        width: "45",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cor&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cor&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cor&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cor&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "DAN",
    vi: "777",
    vn: "DanCenter A/S",
    logo: [
      {
        size: "20",
        width: "72",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dan&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dan&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dan&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dan&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "JI",
    vi: "1052",
    vn: "De Jong Intra Vakanties",
    logo: [
      {
        size: "20",
        width: "37",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=di&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "40",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=di&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=di&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=di&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "DER",
    vi: "207",
    vn: "DERTOUR",
    logo: [
      {
        size: "20",
        width: "74",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "DERD",
    vi: "207",
    vn: "DERTOUR",
    logo: [
      {
        size: "20",
        width: "74",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=der&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "DKT",
    vi: "1092",
    vn: "DK TOURISTIK Reiseconsulting Ges.m.b.H.",
    logo: [
      {
        size: "20",
        width: "45",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dkt&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dkt&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dkt&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dkt&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "DTA",
    vi: "992",
    vn: "dta Touristik GmbH",
    logo: [
      {
        size: "20",
        width: "31",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dta&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dta&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dta&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=dta&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ECC",
    vi: "573",
    vn: "ECCO Reisen GmbH",
    logo: [
      {
        size: "20",
        width: "51",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ecc&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ecc&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ecc&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ecc&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ERNAM",
    vi: "1148",
    vn: "ERNA MEYER REISEN",
    logo: [
      {
        size: "20",
        width: "67",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=emr&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=emr&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=emr&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=emr&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XEUR",
    vi: "985",
    vn: "Eurotours",
    logo: [
      {
        size: "20",
        width: "28",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeur&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeur&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeur&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeur&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "EWH",
    vi: "1117",
    vn: "Eurowings Holidays",
    logo: [
      {
        size: "20",
        width: "124",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ewh&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ewh&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ewh&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ewh&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ETCH",
    vi: "1112",
    vn: "EXIM Tours Car Holiday",
    logo: [
      {
        size: "20",
        width: "68",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etch&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etch&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etch&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etch&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ETDY",
    vi: "1110",
    vn: "EXIM Tours Dynamic",
    logo: [
      {
        size: "20",
        width: "68",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etdy&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etdy&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etdy&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=etdy&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ETI",
    vi: "357",
    vn: "Express Travel International GmbH",
    logo: [
      {
        size: "20",
        width: "32",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ETIS",
    vi: "919",
    vn: "Express Travel International Schweiz",
    logo: [
      {
        size: "20",
        width: "32",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FNTR",
    vi: "1031",
    vn: "Falk Tours GmbH",
    logo: [
      {
        size: "20",
        width: "75",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fntr&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fntr&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fntr&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fntr&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FATV",
    vi: "1121",
    vn: "Falk Tours GmbH",
    logo: [
      {
        size: "20",
        width: "75",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fatv&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fatv&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fatv&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fatv&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FTV",
    vi: "1149",
    vn: "Falktravel",
    logo: [
      {
        size: "20",
        width: "103",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftv&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftv&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftv&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftv&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FER",
    vi: "395",
    vn: "FERIEN Touristik GmbH",
    logo: [
      {
        size: "20",
        width: "49",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fer&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fer&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fer&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fer&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FUV",
    vi: "1104",
    vn: "Fit & Vital Reisen GmbH",
    logo: [
      {
        size: "20",
        width: "31",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fuv&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fuv&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fuv&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fuv&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FIT",
    vi: "298",
    vn: "FIT Gesellschaft für gesundes Reisen mbH",
    logo: [
      {
        size: "20",
        width: "63",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fit&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fit&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fit&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fit&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FLT",
    vi: "910",
    vn: "Flamingo Tours",
    logo: [
      {
        size: "20",
        width: "51",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=flt&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=flt&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=flt&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=flt&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FOR",
    vi: "981",
    vn: "For You Travel",
    logo: [
      {
        size: "20",
        width: "31",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=for&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=for&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=for&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=for&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FRAN",
    vi: "821",
    vn: "Frantour",
    logo: [
      {
        size: "20",
        width: "199",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fran&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fran&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fran&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fran&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FTI",
    vi: "156",
    vn: "FTI",
    logo: [
      {
        size: "20",
        width: "27",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FTI",
    vi: "1138",
    vn: "FTI Österreich",
    logo: [
      {
        size: "20",
        width: "27",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FTIS",
    vi: "525",
    vn: "FTI Schweiz",
    logo: [
      {
        size: "20",
        width: "27",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftis&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftis&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftis&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftis&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FTIV",
    vi: "921",
    vn: "FTI Voyages S.A.",
    logo: [
      {
        size: "20",
        width: "27",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftiv&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftiv&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftiv&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ftiv&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "GIATA",
    vi: "157",
    vn: "GIATA",
    logo: [
      {
        size: "20",
        width: "73",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=giata&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=giata&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=giata&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=giata&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "GIAD",
    vi: "1144",
    vn: "GIATA-Drive",
    logo: [],
  },
  {
    vc: "GER",
    vi: "1113",
    vn: "Globalis Erlebnisreisen GmbH",
    logo: [
      {
        size: "20",
        width: "113",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ger&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ger&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ger&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ger&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "GRUB",
    vi: "315",
    vn: "Gruber Reisen Veranstalter GmbH",
    logo: [
      {
        size: "20",
        width: "145",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=grub&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=grub&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=grub&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=grub&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "HEL",
    vi: "624",
    vn: "Helvetic Tours",
    logo: [
      {
        size: "20",
        width: "26",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hel&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hel&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hel&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hel&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XHEL",
    vi: "1071",
    vn: "Helvetic Tours Dynamic",
    logo: [
      {
        size: "20",
        width: "54",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xhel&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xhel&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xhel&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xhel&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "HLX",
    vi: "1057",
    vn: "HLX Touristik",
    logo: [
      {
        size: "20",
        width: "66",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "HLM",
    vi: "1057",
    vn: "HLX Touristik",
    logo: [
      {
        size: "20",
        width: "66",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hlx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "HOCL",
    vi: "1059",
    vn: "HolidayCloud",
    logo: [
      {
        size: "20",
        width: "57",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hocl&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hocl&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hocl&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hocl&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "HP",
    vi: "579",
    vn: "Hotelplan",
    logo: [
      {
        size: "20",
        width: "58",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hp&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hp&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hp&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hp&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "HTH",
    vi: "914",
    vn: "HTH Hanse Touristik Hamburg GmbH",
    logo: [
      {
        size: "20",
        width: "25",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hth&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hth&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hth&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=hth&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "RIVA",
    vi: "524",
    vn: "I.D. Riva Tours",
    logo: [
      {
        size: "20",
        width: "48",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=riva&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=riva&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=riva&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=riva&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "IDEA",
    vi: "1111",
    vn: "IDEALTOURS GmbH",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=idea&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=idea&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=idea&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=idea&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ICO",
    vi: "1152",
    vn: "Inter-Connect",
    logo: [
      {
        size: "20",
        width: "20",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ico&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "47",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ico&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ico&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ico&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "IHOM",
    vi: "452",
    vn: "Interhome",
    logo: [
      {
        size: "20",
        width: "69",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ihom&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ihom&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ihom&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ihom&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "INTI",
    vi: "1143",
    vn: "Invia",
    logo: [
      {
        size: "20",
        width: "37",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=inti&size=20&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=inti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=inti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ITS",
    vi: "200",
    vn: "ITS",
    logo: [
      {
        size: "20",
        width: "22",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=its&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=its&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=its&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=its&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ITSC",
    vi: "568",
    vn: "ITS Coop Travel",
    logo: [
      {
        size: "20",
        width: "55",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsc&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsc&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsc&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsc&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ITSX",
    vi: "811",
    vn: "ITS Indi",
    logo: [
      {
        size: "20",
        width: "24",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itsx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "ITT",
    vi: "431",
    vn: "ITT Ferien PUR",
    logo: [
      {
        size: "20",
        width: "48",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itt&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itt&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itt&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=itt&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XPUR",
    vi: "998",
    vn: "ITT XPUR",
    logo: [
      {
        size: "20",
        width: "44",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xpur&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xpur&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xpur&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xpur&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XJAHN",
    vi: "899",
    vn: "Jahn Indi",
    logo: [
      {
        size: "20",
        width: "80",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xjahn&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xjahn&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xjahn&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xjahn&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "JAHN",
    vi: "246",
    vn: "Jahn Reisen",
    logo: [
      {
        size: "20",
        width: "61",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jahn&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jahn&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jahn&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jahn&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "JUMB",
    vi: "570",
    vn: "JUMBO Touristik",
    logo: [
      {
        size: "20",
        width: "69",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jumb&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jumb&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jumb&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=jumb&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "NJA1",
    vi: "1126",
    vn: "JUST AWAY",
    logo: [],
  },
  {
    vc: "KUON",
    vi: "318",
    vn: "Kuoni Reisen",
    logo: [
      {
        size: "20",
        width: "86",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=kuon&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=kuon&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=kuon&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=kuon&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TUR3",
    vi: "1146",
    vn: "l'tur Exclusive GmbH (Tui Gruppe)",
    logo: [
      {
        size: "20",
        width: "41",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TUR1",
    vi: "1145",
    vn: "l'tur GmbH (Tui Gruppe)",
    logo: [
      {
        size: "20",
        width: "41",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=ltur&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "LMXI",
    vi: "842",
    vn: "LMX International",
    logo: [
      {
        size: "20",
        width: "46",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmxi&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmxi&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmxi&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmxi&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "LMX",
    vi: "416",
    vn: "LMX Touristik",
    logo: [
      {
        size: "20",
        width: "46",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lmx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "LHH",
    vi: "1060",
    vn: "Lufthansa Holidays",
    logo: [
      {
        size: "20",
        width: "58",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lhh&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lhh&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lhh&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lhh&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "LUX",
    vi: "214",
    vn: "Luxair Tours GmbH",
    logo: [
      {
        size: "20",
        width: "81",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lux&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lux&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lux&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=lux&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "MANT",
    vi: "625",
    vn: "Manta Reisen",
    logo: [
      {
        size: "20",
        width: "103",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mant&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mant&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mant&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mant&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "MED",
    vi: "220",
    vn: "Medina Reisen",
    logo: [
      {
        size: "20",
        width: "51",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=med&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=med&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=med&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=med&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "MWR",
    vi: "244",
    vn: "Meier's Weltreisen",
    logo: [
      {
        size: "20",
        width: "32",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mwr&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mwr&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mwr&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mwr&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XMIG",
    vi: "798",
    vn: "Migros Ferien",
    logo: [
      {
        size: "20",
        width: "53",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xmig&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xmig&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xmig&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xmig&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "MIS",
    vi: "586",
    vn: "Misir Sonnenlandreisen",
    logo: [
      {
        size: "20",
        width: "65",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mis&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mis&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mis&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mis&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "MOA",
    vi: "1159",
    vn: "Moana Reisen",
    logo: [],
  },
  {
    vc: "MON",
    vi: "283",
    vn: "Mondial GmbH & Co. KG",
    logo: [
      {
        size: "20",
        width: "56",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mon&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mon&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mon&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=mon&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XNEC",
    vi: "1164",
    vn: "Neckermann Reisen XNEC, eine Marke der Anex Tour GmbH",
    logo: [
      {
        size: "20",
        width: "50",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xnec&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xnec&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xnec&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xnec&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "NEC",
    vi: "1163",
    vn: "Neckermann Reisen, eine Marke der Anex Tour GmbH",
    logo: [
      {
        size: "20",
        width: "50",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=nec&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=nec&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=nec&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=nec&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "OGE",
    vi: "873",
    vn: "ÖGER TOURS",
    logo: [
      {
        size: "20",
        width: "33",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oge&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oge&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oge&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oge&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XOLI",
    vi: "1130",
    vn: "OLIMAR Outlet",
    logo: [
      {
        size: "20",
        width: "53",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoli&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoli&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoli&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoli&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "OLI",
    vi: "250",
    vn: "Olimar Reisen",
    logo: [
      {
        size: "20",
        width: "41",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oli&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oli&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oli&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=oli&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "PHX",
    vi: "261",
    vn: "Phoenix Reisen",
    logo: [
      {
        size: "20",
        width: "72",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=phx&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=phx&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=phx&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=phx&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "PRIM",
    vi: "577",
    vn: "PRIMA REISEN GMBH",
    logo: [
      {
        size: "20",
        width: "48",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=prim&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=prim&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=prim&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=prim&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "PTI",
    vi: "304",
    vn: "PTI Panoramica Touristik",
    logo: [
      {
        size: "20",
        width: "75",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=pti&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=pti&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=pti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=pti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "RTS",
    vi: "613",
    vn: "railtour suisse sa",
    logo: [
      {
        size: "20",
        width: "56",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rts&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rts&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rts&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rts&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "RHOM",
    vi: "621",
    vn: "Rhomberg - Die Reisemaßschneiderei",
    logo: [
      {
        size: "20",
        width: "62",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rho&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rho&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rho&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rho&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "RSD",
    vi: "1158",
    vn: "RSD Reise Service Deutschland GmbH",
    logo: [
      {
        size: "20",
        width: "37",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rsd&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rsd&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rsd&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rsd&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SLR",
    vi: "227",
    vn: "Schauinsland Reisen",
    logo: [
      {
        size: "20",
        width: "59",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=slr&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=slr&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=slr&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=slr&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SELE",
    vi: "901",
    vn: "Select Holidays GmbH",
    logo: [
      {
        size: "20",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sele&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sele&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sele&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sele&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SIT",
    vi: "801",
    vn: "SITALIA GmbH",
    logo: [
      {
        size: "20",
        width: "66",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sit&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sit&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sit&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sit&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SO",
    vi: "1084",
    vn: "Solaris Travel GmbH",
    logo: [
      {
        size: "20",
        width: "90",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=so&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=so&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=so&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=so&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SOFY",
    vi: "1107",
    vn: "SolFly",
    logo: [
      {
        size: "20",
        width: "58",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sofy&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sofy&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sofy&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sofy&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SPRI",
    vi: "610",
    vn: "SPRINGER REISEN",
    logo: [
      {
        size: "20",
        width: "71",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=spri&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=spri&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=spri&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=spri&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SUNH",
    vi: "939",
    vn: "SunHotels",
    logo: [
      {
        size: "20",
        width: "55",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sunh&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sunh&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sunh&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=sunh&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TUT",
    vi: "1162",
    vn: "Tierische Urlaubsträume",
    logo: [
      {
        size: "20",
        width: "20",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tut&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tut&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tut&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tut&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TIMA",
    vi: "1161",
    vn: "Tierramare GmbH",
    logo: [
      {
        size: "20",
        width: "13",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tima&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tima&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tima&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tima&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TISC",
    vi: "332",
    vn: "Tischler",
    logo: [
      {
        size: "20",
        width: "20",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tisc&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tisc&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tisc&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tisc&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TOP",
    vi: "1068",
    vn: "TOP Touristik",
    logo: [
      {
        size: "20",
        width: "21",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=top&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=top&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=top&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=top&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TOU",
    vi: "1156",
    vn: "Tourenia",
    logo: [
      {
        size: "20",
        width: "85",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tou&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tou&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tou&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tou&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TPT",
    vi: "932",
    vn: "TPT - Tourisme Pour Tous",
    logo: [
      {
        size: "20",
        width: "63",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tpt&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tpt&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tpt&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tpt&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TRANS",
    vi: "1096",
    vn: "TRANSAIR - TRANS",
    logo: [
      {
        size: "20",
        width: "66",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trans&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trans&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trans&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trans&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TRAL",
    vi: "1141",
    vn: "TraveLeague AG",
    logo: [
      {
        size: "20",
        width: "55",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tral&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tral&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tral&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tral&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "REBAA",
    vi: "1047",
    vn: "Travelhouse",
    logo: [
      {
        size: "20",
        width: "115",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rebaa&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rebaa&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rebaa&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=rebaa&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XTJS",
    vi: "689",
    vn: "TRAVELIX",
    logo: [
      {
        size: "20",
        width: "35",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtjs&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtjs&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtjs&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtjs&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TJAX",
    vi: "938",
    vn: "TRAVELIX TJAX",
    logo: [
      {
        size: "20",
        width: "35",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tjax&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tjax&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tjax&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tjax&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TREX",
    vi: "698",
    vn: "TravelTrex GmbH - HolidayTrex",
    logo: [
      {
        size: "20",
        width: "133",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trex&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trex&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trex&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trex&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "SNOW",
    vi: "429",
    vn: "TravelTrex GmbH - SnowTrex Wintersportreisen",
    logo: [
      {
        size: "20",
        width: "79",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=snow&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=snow&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=snow&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=snow&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TRND",
    vi: "1160",
    vn: "Trendtours Touristik",
    logo: [
      {
        size: "20",
        width: "27",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trnd&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trnd&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trnd&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trnd&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TROL",
    vi: "319",
    vn: "Troll Tours Reisen",
    logo: [
      {
        size: "20",
        width: "44",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trol&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trol&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trol&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=trol&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TUID",
    vi: "199",
    vn: "TUI",
    logo: [
      {
        size: "20",
        width: "48",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tui&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tui&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tui&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tui&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "TUIS",
    vi: "345",
    vn: "TUI Suisse",
    logo: [
      {
        size: "20",
        width: "82",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tuis&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tuis&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tuis&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=tuis&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "UNIV",
    vi: "1136",
    vn: "UNIVERSAL FLUGREISEN AG",
    logo: [
      {
        size: "20",
        width: "55",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=univ&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=univ&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=univ&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=univ&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XUSA",
    vi: "1131",
    vn: "USA-Reisen Experte",
    logo: [
      {
        size: "20",
        width: "100",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xusa&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xusa&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xusa&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xusa&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FRE",
    vi: "1086",
    vn: "Voordeeluitjes.nl",
    logo: [
      {
        size: "20",
        width: "172",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fre&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fre&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fre&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fre&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "VTO",
    vi: "450",
    vn: "Vtours GmbH",
    logo: [
      {
        size: "20",
        width: "79",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vto&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vto&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vto&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vto&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "VTOI",
    vi: "1064",
    vn: "Vtours International",
    logo: [
      {
        size: "20",
        width: "66",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vtoi&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vtoi&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vtoi&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vtoi&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "VRG",
    vi: "1125",
    vn: "W-Reservation",
    logo: [
      {
        size: "20",
        width: "35",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vrg&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vrg&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vrg&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=vrg&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "WIN",
    vi: "1120",
    vn: "Windrose",
    logo: [
      {
        size: "20",
        width: "78",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=win&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=win&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=win&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=win&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XBIG",
    vi: "830",
    vn: "XBIG",
    logo: [
      {
        size: "20",
        width: "48",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xbig&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xbig&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xbig&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xbig&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XETI",
    vi: "927",
    vn: "XExpress Travel International GmbH",
    logo: [
      {
        size: "20",
        width: "57",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeti&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeti&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeti&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xeti&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XTUI",
    vi: "807",
    vn: "XTUI",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtui&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtui&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtui&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xtui&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XOGE",
    vi: "852",
    vn: "XÖGER",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoge&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoge&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoge&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xoge&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "FIB",
    vi: "1168",
    vn: "Fibula Travel GmbH",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fib&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fib&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fib&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=fib&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "DEH",
    vi: "1169",
    vn: "Condor Holidays",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=deh&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=deh&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=deh&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=deh&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "WFT",
    vi: "1170",
    vn: "We Flytour",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=wft&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=wft&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=wft&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=wft&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "COS",
    vi: "1171",
    vn: "Coral Travel AG Schweiz",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cos&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cos&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cos&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=cos&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "XCOS",
    vi: "1172",
    vn: "Coral Travel AG Schweiz dynamic",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xcos&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xcos&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xcos&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=xcos&size=288&uid=1580&source=xml",
      },
    ],
  },
  {
    vc: "EYH",
    vi: "1174",
    vn: "Etihad Holidays (operated by Capital Holidays Europe)",
    logo: [
      {
        size: "20",
        width: "64",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eyh&size=20&uid=1580&source=xml",
      },
      {
        size: "40",
        width: "40",
        height: "20",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eyh&size=40&uid=1580&source=xml",
      },
      {
        size: "140",
        width: "140",
        height: "30",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eyh&size=140&uid=1580&source=xml",
      },
      {
        size: "288",
        width: "288",
        height: "61",
        url: "https://m.giatamedia.com/getVeaLogo.php?vea=eyh&size=288&uid=1580&source=xml",
      },
    ],
  },
];
